import {Button, Loader, Modal} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

import {TrustFrame} from './TrustFrame'
import {useTrustModal} from './TrustModal.hooks'
import {Props} from './TrustModal.types'

const classes = {
  modal: css`
    inline-size: ${spacing(70)};
    min-block-size: 23.8rem;
    justify-content: center;
    align-items: stretch;
  `,
}

export function TrustModal(props: Props): React.ReactElement<Props> {
  const {onClose, onSuccess} = props
  const {isPending, bindingUrl, bindingType, error, translates, updateHandler} = useTrustModal(props)

  return (
    <Modal onClose={onClose} opened>
      <Modal.Header text={translates.subtitle} title={translates.title} />
      {bindingUrl && bindingType ? (
        <TrustFrame
          bindingType={bindingType}
          bindingUrl={bindingUrl}
          classes={classes}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      ) : (
        <Modal.Body className={classes.modal} justifyContent="center">
          {isPending ? (
            <Loader size="m" />
          ) : error ? (
            <Button onPress={updateHandler} variant="action">
              {translates.repeat}
            </Button>
          ) : (
            '🤷'
          )}
        </Modal.Body>
      )}
    </Modal>
  )
}
